import React from 'react';
import classNames from 'classnames';
import NylAlert from '../../common/components/NylAlert';

const bodyTextClassname = "nyl-alert__body__text";
const strongTextClassname = `${bodyTextClassname}--strong`

const ForgotPasswordSuccessAlert = ({ email }) => (
  <NylAlert
    title='Check Your Inbox!'
    titleHeadingLevel={2}
    titleTextProps={{ size: 'large' }}
    body={
      <p className={classNames(bodyTextClassname, 'text-center', 'mt-3', 'mb-0')}>
        You should receive a password reset email at{" "}
        <strong className={strongTextClassname}>{email}</strong> shortly. Be sure to check your
        junk and spam folders just in case.
      </p>
    }
  />
);

export default ForgotPasswordSuccessAlert;
